/** Shared client-side form validation patterns (react-hook-form friendly). */

export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const EMAIL_REQUIRED_MESSAGE = 'Email is required';
export const EMAIL_INVALID_MESSAGE = 'Invalid email address';

/** Default `register('email', …)` options for a required email field. */
export const emailRegisterOptions = {
    required: EMAIL_REQUIRED_MESSAGE,
    pattern: {
        value: EMAIL_PATTERN,
        message: EMAIL_INVALID_MESSAGE,
    },
} as const;

export function isValidEmail(value: string): boolean {
    return EMAIL_PATTERN.test(value);
}

/** Cognito user-pool style password policy used for set-new-password / invite flows. */
export const COGNITO_PASSWORD_HINT =
    'Password must be at least 8 characters and contain uppercase, lowercase, a number, and a special character (e.g. !@#$%^&*).';

export const COGNITO_PASSWORD_POLICY = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;

export function isValidCognitoPassword(value: string): boolean {
    return COGNITO_PASSWORD_POLICY.test(value);
}
